import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/base-components/Icon";
import { Input } from "src/base-components/Input";
import { Select } from "src/base-components/Select";
import { getSchemaIcon } from "src/entities/entityView/utils";
import { EntitySchemaResource } from "src/entities/queries";

type Props = {
  entitySchema: EntitySchemaResource;
  propertyKey: string;
};

export const EntityOptionValue = ({
  entitySchema,
  singular = false,
}: {
  entitySchema: EntitySchemaResource;
  singular?: boolean;
}) => {
  return (
    <div className="flex items-center gap-2">
      <Icon
        color="text-gray-500"
        icon={getSchemaIcon(entitySchema)}
        size="xs"
      />
      {singular
        ? entitySchema._display_name_singular
        : entitySchema._display_name_plural}
    </div>
  );
};

export const EntityTypeSelector: React.FC<Props> = ({
  entitySchema,
  propertyKey,
}) => {
  return (
    <div className="flex flex-col gap-y-3">
      <p className="font-inter-medium-12px text-gray-800">Select Entity Type</p>
      <div className="flex items-end gap-x-2">
        <div className="flex-1">
          <p className="pb-2 font-inter-normal-12px text-gray-500">
            Select entity
          </p>
          <Select
            options={[
              {
                value: <EntityOptionValue entitySchema={entitySchema} />,
                key: entitySchema._id,
              },
            ]}
            placeholder="Select Entity Type"
            value={entitySchema._id}
            disabled
          />
        </div>
        <Icon color="text-gray-500 pb-1.5" icon={faArrowRight} size="xs" />
        <div className="flex-1">
          <p className="pb-2 font-inter-normal-12px text-gray-500">Key</p>
          <Input value={propertyKey} disabled fullWidth />
        </div>
      </div>
    </div>
  );
};
